module.exports = __webpack_public_path__ + "static/img/jigou-anhui-top.baeebf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-anhui-top.png
// module id = Nh9h
// module chunks = 2